import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertFacade } from '@core/alert.facade';
import { FuseAlertType } from '@fuse/components/alert';
import { AppAlert } from '@models';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _alertFacade: AlertFacade) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(req)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          throwError(() => this._alertFacade.show(mapErrorToAlert(error)))
        )
      );
  }
}

const mapErrorToAlert = (error: HttpErrorResponse): AppAlert => ({
  duration: 5000,
  message: error.message,
  name: '',
  showCloseButton: true,
  type: statusToAlertTypeMap[
    error.status as HttpStatusCode | 0
  ] as FuseAlertType,
});

const statusToAlertTypeMap: Partial<Record<HttpStatusCode | 0, FuseAlertType>> =
  {
    0: 'error',
    [HttpStatusCode.Unauthorized]: 'warning',
    [HttpStatusCode.Forbidden]: 'warning',
    [HttpStatusCode.BadRequest]: 'warning',
    [HttpStatusCode.NotFound]: 'error',
    [HttpStatusCode.InternalServerError]: 'error',
    [HttpStatusCode.Ok]: 'success',
  };

const statusToMessageMap: Partial<Record<HttpStatusCode | 0, string>> = {
  0: 'http_error.internal_error',
  [HttpStatusCode.Unauthorized]: 'http_error.unauthorized',
  [HttpStatusCode.Forbidden]: 'http_error.forbidden',
  [HttpStatusCode.BadRequest]: 'http_error.bad_request',
  [HttpStatusCode.NotFound]: 'http_error.not_found',
  [HttpStatusCode.InternalServerError]: 'http_error.internal_error',
  [HttpStatusCode.Ok]: 'http_error.success',
};
